import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, Input } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ActivatedRoute } from '@angular/router';
import { ExtraService } from '../../core/services/extra.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { NewPageService } from './service/new-page.service';
import { from } from 'rxjs/observable/from';
import { NewPageList } from '../../core/models/new-page-list';
import { ListWithinList } from '../../core/models/list-within-list';
import { Constants } from '../../core/config/Constants';

@Component({
  selector: 'app-new-page',
  templateUrl: './new-page.component.html',
  styleUrls: ['./new-page.component.css'],
  providers: [ExtraService, NewPageService]
})
export class NewPageComponent {


  @Input() pageTitle: string;
  @Input() pageSlug: string;


  @ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;

  eventId: string;
  disableButton: boolean = false;
  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;

  list = new Array<NewPageList>();

  constructor(
    private newPageService: NewPageService, 
    private _cfr: ComponentFactoryResolver, 
    private extraService: ExtraService, 
    private route: ActivatedRoute
    ) {


  }

  isError: boolean = false;
  errorMessages = new Array<string>();
  message: string;

  ngOnChanges() {
    console.log("Page Title", this.pageTitle);
    console.log("Page Slug", this.pageSlug);
  }
  ngOnInit(): void {

    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {
      let id = params['eventId'];
      if (id) {
        this.extraService.setCurrentEventId(id);
        this.eventId = id;
        this.getNewPageList(id);
      }
    });
    this.newPageService.up$.subscribe(data => {
      if (data != null) {
        let index = this.list.indexOf(data);
        if (index > 0) {
          this.swap(index, index - 1);
        }
      }
    });
    this.newPageService.down$.subscribe(data => {
      if (data != null) {
        let index = this.list.indexOf(data);
        if (index < this.list.length - 1) {
          this.swap(index, index + 1);
        }
      }
    });
    this.newPageService.remove$.subscribe(data => {
      if (data != null) {
        let index = this.list.indexOf(data);
        console.log(index);
        if (index != -1) {
          this.remove(index);
        }
      }
    });
  }

  getNewPageList(id) {
    this.newPageService.getNewPageList(id, this.pageSlug).subscribe(newPageList => {
      if (newPageList) {
        this.dropDown.clear();
        this.list = newPageList;
        this.list.forEach(element => {
          this.addComponent(element);
        });
      }
    });
  }

  showDropDown() {
    let aboutUs = new NewPageList();
    var dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
    var expComponent = this.dropDown.createComponent(dropDown);
    this.list.push(aboutUs);
    expComponent.instance.eventId = this.eventId;
    expComponent.instance._ref = expComponent;
    expComponent.instance.aboutUs = this.list[this.list.length - 1];
    expComponent.instance.message = this.message;
  }

  submit() {
    this.disableButton = true;
    console.log(this.list);
    this.newPageService.addValidation(true);
    this.newPageService.addValidation(false);
    this.errorMessages = new Array();
    this.isError = false;
    this.message = null;
    let that = this;
    if (this.validate()) {
      this.newPageService.setNewPageList(this.eventId, this.list, this.pageSlug).then(res => {
        this.message = `${that.pageTitle} updated Successfully`;
        setTimeout(function () {
          this.message = null;
          this.disableButton = false;
        }.bind(this), 2000);
      }).catch(error => {
        this.message = 'something went wrong';
        console.log(error.message);
        this.isError = true;
      });
      this.getNewPageList(this.eventId);
    } else {
      this.isError = true;
      this.disableButton = false;
    }
  }

  swap(index1, index2) {
    this.dropDown.move(this.dropDown.get(index1), index2);
    let data = this.list[index1];
    this.list[index1] = this.list[index2];
    this.list[index2] = data;
  }

  remove(index) {
    this.list = this.list.filter((val, i) => i != index);
  }

  validate(): boolean {
    let valid = true;
    this.list.forEach(element => {
      if (element.type == 'text' && (element.text == null || element.text.trim().length < 1)) {
        if (this.errorMessages.indexOf('Text cannot empty') == -1) {
          this.errorMessages.push('Text cannot empty');
        }
        valid = false;
      }
      if (element.type == 'url' && (element.url == null || element.url.trim().length < 1)) {
        if (this.errorMessages.indexOf('Url cannot empty') == -1) {
          this.errorMessages.push('Url cannot empty');
        }
        valid = false;
      }
      if (element.type == 'youtubeVideo' && (element.url == null || element.url.trim().length < 1)) {
        if (this.errorMessages.indexOf('Youtube url cannot empty') == -1) {
          this.errorMessages.push('Youtube url cannot empty');
        }
        valid = false;
      }
      if (element.type == 'cards') {
        element.listItems.forEach(item => {
          if (item == null || item.trim().length < 1) {
            if (this.errorMessages.indexOf('Card text cannot empty') == -1) {
              this.errorMessages.push('Card text cannot empty');
            }
            valid = false;
          }
        });
      }
      if (element.type == 'image' && element.contentMandatoryList.length < 1) {
        if (this.errorMessages.indexOf('please browse an image') == -1) {
          this.errorMessages.push('please browse an image');
        }
        valid = false;
      }
      if (element.type == 'video' && element.contentMandatoryList.length < 1) {
        if (this.errorMessages.indexOf('please browse an video') == -1) {
          this.errorMessages.push('please browse an video');
        }
        valid = false;
      }
      if (element.type == 'list' && (element.listWithinListList == null || element.listWithinListList.length < 1)) {
        if (this.errorMessages.indexOf('Add atleast one list item') == -1) {
          this.errorMessages.push('Add atleast one list item');
        }
        valid = false;
      } else if (element.type == 'list' && element.listWithinListList.length == 1 && element.listWithinListList[0].hasSubList == null) {
        if (this.errorMessages.indexOf('Add atleast one list item') == -1) {
          this.errorMessages.push('Add atleast one list item');
        }
        valid = false;
      } else if (element.type == 'list' && element.listWithinListList != null && element.listWithinListList.length > 0) {
        element.listWithinListList.forEach(subList => {
          let bool = this.validateList(subList);
          if (!bool) {
            valid = false;
          }
        });
      }
      if (element.type == null || element.type.trim().length < 1) {
        this.remove(this.list.indexOf(element));
      }

    });
    return valid;
  }

  addComponent(about: NewPageList) {
    var dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
    var expComponent = this.dropDown.createComponent(dropDown);
    expComponent.instance.eventId = this.eventId;
    expComponent.instance._ref = expComponent;
    expComponent.instance.aboutUs = about;
    if (about.type == 'image') {
      expComponent.instance.addImage();
    } else if (about.type == 'text') {
      expComponent.instance.addTextBox();
    } else if (about.type == 'cards') {
      expComponent.instance.addCards();
    } else if (about.type == 'video') {
      expComponent.instance.addVideo();
    } else if (about.type == 'url') {
      expComponent.instance.addUrlBox();
    } else if (about.type == 'youtubeVideo') {
      expComponent.instance.addYoutube();
    } else if (about.type == 'imageSlider') {
      expComponent.instance.addImageSlider();
    } else if (about.type == 'list') {
      expComponent.instance.addList();
    } else {
      expComponent.instance.addStatic(about.type);
    }
  }

  validateList(listWithinList: ListWithinList): boolean {
    let valid = true;
    if ((listWithinList.hasSubList != null && (listWithinList.text == null || listWithinList.text.length < 1))) {
      if (this.errorMessages.indexOf('list field cannot empty') == -1) {
        this.errorMessages.push('list field cannot empty');
      }
      valid = false;
    }
    if (listWithinList.hasSubList && listWithinList.listWithinListList != null && listWithinList.listWithinListList.length > 0) {
      listWithinList.listWithinListList.forEach(subList => {
        valid = this.validateList(subList);
      });
    }
    return valid;
  }

}






// WEBPACK FOOTER //
// /app/src/app/templates/new-page/new-page.component.ts